import { render, staticRenderFns } from "./DnsPolicy.vue?vue&type=template&id=7601701a&"
import script from "./DnsPolicy.vue?vue&type=script&lang=js&"
export * from "./DnsPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports